export default "__VITE_ASSET__BToGg3T$__"